/* ============================================================
   ON FORCE THEME — Extended Features
   Wishlist, Recently Viewed, Social Proof, Countdown,
   Upsell Modal, Cookie Banner, Back-to-Top, Quick View, Bundle
   ============================================================ */
(function () {
  'use strict';

  const toast = window.showToast || function () {};
  const fmt = window.formatMoney || function (c) { return 'CHF ' + (c / 100).toFixed(2); };

  // ============================================================
  //  WISHLIST (localStorage)
  // ============================================================
  const WISHLIST_KEY = 'on_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function toggleWishlist(productId) {
    const list = getWishlist();
    const id = String(productId);
    const idx = list.indexOf(id);
    const added = idx === -1;
    if (added) { list.push(id); toast('Zur Wunschliste hinzugefügt', 'wish'); }
    else { list.splice(idx, 1); toast('Aus Wunschliste entfernt', 'error'); }
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistUI(id, added);
    return added;
  }
  function updateWishlistUI(productId, isWishlisted) {
    document.querySelectorAll('[data-wishlist="' + productId + '"]').forEach(btn => {
      btn.classList.toggle('wishlisted', isWishlisted);
      btn.classList.toggle('active', isWishlisted); // Kompatibilität mit .pc__wishlist.active CSS
    });
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function initWishlist() {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist]').forEach(btn => {
      const id = String(btn.dataset.wishlist);
      const isIn = list.indexOf(id) > -1;
      btn.classList.toggle('wishlisted', isIn);
      btn.classList.toggle('active', isIn); // Kompatibilität mit .pc__wishlist.active CSS
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        toggleWishlist(id);
      });
    });
    const count = list.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  window.toggleWishlist = toggleWishlist;

  // ============================================================
  //  RECENTLY VIEWED (localStorage)
  // ============================================================
  const RV_KEY = 'on_recently_viewed';
  const RV_MAX = 8;
  function trackRecentlyViewed(product) {
    try {
      let list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      list = list.filter(p => p.id !== product.id);
      list.unshift(product);
      if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function renderRecentlyViewed(container, excludeId) {
    try {
      const list = JSON.parse(localStorage.getItem(RV_KEY) || '[]')
        .filter(p => p.id !== excludeId).slice(0, 4);
      const section = container.closest('.recently-viewed-section');
      if (!list.length) { if (section) section.style.display = 'none'; return; }
      container.innerHTML = list.map(p =>
        '<a href="' + p.url + '" class="product-card product-card--mini">' +
        '<div class="product-card__img-wrap"><img class="product-card__img" src="' + p.image + '" alt="" loading="lazy"></div>' +
        '<div class="product-card__vendor">' + (p.vendor || '') + '</div>' +
        '<div class="product-card__title">' + p.title + '</div>' +
        '<div class="product-card__price">' + p.price + '</div></a>'
      ).join('');
    } catch (e) {}
  }

  // ============================================================
  //  SOCIAL PROOF POPUPS
  // ============================================================
  function initSocialProof() {
    // Konfiguration kommt aus der Section "social-proof" (window.socialProofConfig)
    var cfg = window.socialProofConfig;
    // Fallback auf alte globale Einstellung
    if (!cfg) {
      if (!window.themeSettings || !window.themeSettings.enableSocialProof) return;
      cfg = { enabled: true, mode: 'auto', position: 'bottom-left', showOn: 'all',
              startDelay: 8000, displayDuration: 5000, interval: 15000, randomOrder: false,
              names: '', cities: '', agos: '', verified: true };
    }
    if (!cfg.enabled) return;

    // Seiten-Filter
    var showOn = cfg.showOn || 'all';
    if (showOn !== 'all') {
      if (!document.body.classList.contains('template-' + showOn)) return;
    }

    // Helper: kommagetrennte Liste -> Array
    function toList(str) {
      if (!str) return [];
      return String(str).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

    var names = toList(cfg.names);
    var cities = toList(cfg.cities);
    var agos = toList(cfg.agos);

    // Daten aus der Section laden
    var raw = [];
    var el = document.getElementById('social-proof-data');
    if (el) {
      try { raw = JSON.parse(el.textContent) || []; } catch (e) { raw = []; }
    }
    if (window.socialProofData && window.socialProofData.length) {
      raw = raw.concat(window.socialProofData);
    }
    if (!raw.length) return;

    // Auto-Felder auffüllen (Name/Stadt/Zeit falls leer)
    var data = raw.map(function (d) {
      return {
        name: d.name || (names.length ? pick(names) : 'Ein Kunde'),
        city: d.city || (cities.length ? pick(cities) : ''),
        product: d.product || '',
        ago: d.ago || (agos.length ? pick(agos) : ''),
        image: d.image || '',
        url: d.url || ''
      };
    });

    if (cfg.randomOrder) {
      data.sort(function () { return Math.random() - 0.5; });
    }

    var idx = 0;
    var popup = document.createElement('div');
    popup.className = 'social-proof-popup social-proof-popup--' + (cfg.position || 'bottom-left');
    document.body.appendChild(popup);

    function render(d) {
      var img = d.image
        ? '<img class="sp-img" src="' + d.image + '" alt="' + (d.product || '') + '" width="40" height="40">'
        : '<div class="sp-img-placeholder">ON</div>';
      var line = d.name + (d.city ? ' aus ' + d.city : '') + ' kaufte ' + d.product;
      var verified = cfg.verified ? '<span class="sp-verified" title="verifiziert">✓</span>' : '';
      var inner = img + '<div class="sp-text"><span class="sp-main">' + line + verified + '</span><span class="sp-time">' + d.ago + '</span></div>';
      popup.innerHTML = d.url ? '<a href="' + d.url + '" class="sp-link">' + inner + '</a>' : inner;
    }

    function show() {
      var d = data[idx % data.length]; idx++;
      render(d);
      popup.classList.add('show');
      setTimeout(function () {
        popup.classList.remove('show');
        setTimeout(show, cfg.interval || 12000);
      }, cfg.displayDuration || 5000);
    }
    setTimeout(show, cfg.startDelay || 5000);
  }


  // ============================================================
  //  COUNTDOWN TIMERS
  // ============================================================
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(el => {
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      const fmtN = n => String(n).padStart(2, '0');
      function tick() {
        const diff = end - Date.now();
        if (diff <= 0) { const wrap = el.closest('.countdown-wrap'); if (wrap) wrap.innerHTML = '<strong>Angebot abgelaufen</strong>'; return; }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        el.innerHTML =
          '<div class="cd-unit"><span class="cd-num">' + fmtN(h) + '</span><span class="cd-lbl">Std</span></div>' +
          '<span class="cd-sep">:</span>' +
          '<div class="cd-unit"><span class="cd-num">' + fmtN(m) + '</span><span class="cd-lbl">Min</span></div>' +
          '<span class="cd-sep">:</span>' +
          '<div class="cd-unit"><span class="cd-num">' + fmtN(s) + '</span><span class="cd-lbl">Sek</span></div>';
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  // ============================================================
  //  QUICK VIEW MODAL
  // ============================================================
  async function openQuickView(handle) {
    const modal = document.getElementById('quick-view-modal');
    const content = document.getElementById('qv-content');
    if (!modal || !content) { window.location = '/products/' + handle; return; }
    content.innerHTML = '<div class="qv-loading"><div class="spinner"></div></div>';
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    try {
      const res = await fetch('/products/' + handle + '?view=quick-view');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.getElementById('qv-inner');
      content.innerHTML = inner ? inner.outerHTML :
        '<div style="text-align:center;padding:40px"><a href="/products/' + handle + '" class="btn btn-primary">Zum Produkt →</a></div>';
    } catch (e) {
      content.innerHTML = '<p style="text-align:center;padding:40px">Fehler beim Laden.</p>';
    }
  }
  function closeQuickView() {
    const modal = document.getElementById('quick-view-modal');
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;

  function initQuickView() {
    document.querySelectorAll('[data-quick-view]').forEach(btn => {
      btn.addEventListener('click', e => { e.preventDefault(); openQuickView(btn.dataset.quickView); });
    });
    const modal = document.getElementById('quick-view-modal');
    if (modal) {
      modal.querySelectorAll('[data-qv-close]').forEach(el => el.addEventListener('click', closeQuickView));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') closeQuickView(); });
    }
  }

  // ============================================================
  //  UPSELL MODAL
  // ============================================================
  function showUpsellModal(products) {
    const old = document.getElementById('upsell-modal-dynamic');
    if (old) old.remove();
    const modal = document.createElement('div');
    modal.id = 'upsell-modal-dynamic';
    modal.className = 'upsell-modal';
    modal.innerHTML =
      '<div class="modal-backdrop open" data-up-close></div>' +
      '<div class="modal-box upsell-modal__box">' +
      '<button class="modal-close" data-up-close>✕</button>' +
      '<h3>Häufig zusammen gekauft</h3><p>Ergänze deine Bestellung:</p>' +
      products.map(p =>
        '<div class="upsell-product"><img src="' + p.image + '" alt="">' +
        '<div style="flex:1"><div class="up-title">' + p.title + '</div><div class="up-price">' + p.price + '</div></div>' +
        '<button class="btn btn-primary btn-sm" data-up-add="' + p.variantId + '">+ Hinzufügen</button></div>'
      ).join('') +
      '<button class="btn btn-ghost btn-full" data-up-close style="margin-top:16px">Nein danke</button></div>';
    document.body.appendChild(modal);
    setTimeout(() => modal.classList.add('open'), 10);
    modal.querySelectorAll('[data-up-close]').forEach(el => el.addEventListener('click', () => { modal.classList.remove('open'); setTimeout(() => modal.remove(), 300); }));
    modal.querySelectorAll('[data-up-add]').forEach(btn => {
      btn.addEventListener('click', async () => {
        btn.classList.add('btn--loading');
        try { await window.addToCart(btn.dataset.upAdd, 1); await window.refreshCart(); btn.textContent = '✓'; btn.classList.add('btn--success'); }
        catch (e) {} finally { btn.classList.remove('btn--loading'); }
      });
    });
  }
  window.showUpsellModal = showUpsellModal;

  // ============================================================
  //  COOKIE BANNER
  // ============================================================
  function initCookieBanner() {
    const banner = document.getElementById('cookie-banner');
    if (!banner || localStorage.getItem('on_cookies')) return;
    setTimeout(() => banner.classList.add('show'), 1500);
    const accept = banner.querySelector('[data-accept]');
    const decline = banner.querySelector('[data-decline]');
    if (accept) accept.addEventListener('click', () => { localStorage.setItem('on_cookies', 'accepted'); banner.classList.remove('show'); });
    if (decline) decline.addEventListener('click', () => { localStorage.setItem('on_cookies', 'declined'); banner.classList.remove('show'); });
  }

  // ============================================================
  //  BACK TO TOP
  // ============================================================
  function initBackToTop() {
    const btn = document.getElementById('back-to-top');
    if (!btn) return;
    window.addEventListener('scroll', () => btn.classList.toggle('visible', window.scrollY > 600), { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // ============================================================
  //  BUNDLE BUILDER
  // ============================================================
  function initBundleBuilder() {
    const builder = document.getElementById('bundle-builder');
    if (!builder) return;
    const discount = parseFloat(builder.dataset.discount || '15');
    const state = {};

    builder.querySelectorAll('.bundle-product-card').forEach(card => {
      card.addEventListener('click', () => {
        const step = card.dataset.step;
        builder.querySelectorAll('.bundle-product-card[data-step="' + step + '"]').forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        state[step] = { variantId: card.dataset.variantId, price: parseInt(card.dataset.price), name: card.dataset.name, img: card.dataset.img };
        updateSummary();
      });
    });

    function updateSummary() {
      const thumbs = document.getElementById('bundle-thumbs');
      const fullEl = document.getElementById('bundle-full-price');
      const bundleEl = document.getElementById('bundle-price');
      const saveEl = document.getElementById('bundle-save');
      const atc = document.getElementById('bundle-atc');
      const steps = Object.keys(state);
      let full = 0;
      steps.forEach(s => full += state[s].price);
      const bundlePrice = Math.round(full * (1 - discount / 100));
      if (thumbs) thumbs.innerHTML = steps.map(s => '<img src="' + state[s].img + '" alt="">').join('');
      if (fullEl) fullEl.textContent = fmt(full);
      if (bundleEl) bundleEl.textContent = fmt(bundlePrice);
      if (saveEl) saveEl.textContent = '−' + discount + '% · Du sparst ' + fmt(full - bundlePrice);
      const totalSteps = parseInt(builder.dataset.steps || '3');
      if (atc) atc.disabled = steps.length < totalSteps;
    }

    const atc = document.getElementById('bundle-atc');
    if (atc) {
      atc.addEventListener('click', async () => {
        const items = Object.keys(state).map(s => ({ id: parseInt(state[s].variantId), quantity: 1 }));
        if (!items.length) return;
        atc.classList.add('btn--loading');
        try {
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
          await window.refreshCart();
          window.openCartDrawer();
          toast('Bundle hinzugefügt!', 'success');
        } catch (e) { toast('Fehler', 'error'); }
        finally { atc.classList.remove('btn--loading'); }
      });
    }
  }

  // ============================================================
  //  INIT
  // ============================================================
  document.addEventListener('DOMContentLoaded', function () {
    initWishlist();
    initSocialProof();
    initCountdowns();
    initQuickView();
    initCookieBanner();
    initBackToTop();
    initBundleBuilder();

    if (window.currentProduct) trackRecentlyViewed(window.currentProduct);
    const rv = document.getElementById('recently-viewed-grid');
    if (rv) renderRecentlyViewed(rv, window.currentProduct ? window.currentProduct.id : null);
  });
})();

/* ============================================================
   PRODUCT RECOMMENDATIONS (Shopify Recommendations API)
   ============================================================ */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var box = document.querySelector('[data-recommendations]');
    if (!box) return;
    var grid = box.querySelector('.product-grid') || document.getElementById('recommendations-grid');
    var pid = box.getAttribute('data-product-id');
    var limit = box.getAttribute('data-limit') || 4;
    if (!pid || !grid) return;
    var url = '/recommendations/products?section_id=product-recommendations&product_id=' + pid + '&limit=' + limit;
    // Fallback: nutze die JSON-API + render einfache Karten
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=' + limit)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) {
          var sec = box.closest('.section'); if (sec) sec.style.display = 'none';
          return;
        }
        grid.innerHTML = data.products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var price = (typeof window.formatMoney === 'function') ? window.formatMoney(p.price) : ('CHF ' + (p.price / 100).toFixed(2));
          return '<div class="product-card">' +
            '<div class="product-card__img-wrap"><a href="' + p.url + '">' +
            (img ? '<img class="product-card__img" src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' : '') +
            '</a></div>' +
            '<a href="' + p.url + '"><div class="product-card__title">' + p.title + '</div></a>' +
            '<div class="product-card__price"><span class="price"><span class="price__regular">' + price + '</span></span></div>' +
            '</div>';
        }).join('');
        if (typeof window.reinitProductCards === 'function') window.reinitProductCards();
      })
      .catch(function () {
        var sec = box.closest('.section'); if (sec) sec.style.display = 'none';
      });
  });
})();

/* ============================================================
   COLLECTION FILTER COLLAPSE + LOAD MORE
   ============================================================ */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Einklappbare Filtergruppen
    document.querySelectorAll('.filter-section').forEach(function (sec) {
      var head = sec.querySelector('h4');
      if (!head) return;
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.classList.add('filter-section__head');
      // Standard: offen
      head.addEventListener('click', function () {
        sec.classList.toggle('collapsed');
      });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sec.classList.toggle('collapsed'); }
      });
    });

    // Load-More
    var loadBtn = document.getElementById('load-more-btn');
    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        var nextUrl = loadBtn.getAttribute('data-next-url');
        if (!nextUrl) return;
        loadBtn.classList.add('btn--loading');
        fetch(nextUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid');
            var grid = document.getElementById('product-grid');
            if (newGrid && grid) {
              Array.prototype.forEach.call(newGrid.children, function (child) {
                grid.appendChild(child.cloneNode(true));
              });
            }
            var newBtn = doc.getElementById('load-more-btn');
            if (newBtn && newBtn.getAttribute('data-next-url')) {
              loadBtn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            } else {
              loadBtn.style.display = 'none';
            }
            if (typeof window.reinitProductCards === 'function') window.reinitProductCards();
          })
          .finally(function () { loadBtn.classList.remove('btn--loading'); });
      });
    }
  });
})();

/* ============================================================
   ADDRESS MANAGEMENT (Konto > Adressen)
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-address-toggle]');
    if (toggle) {
      e.preventDefault();
      var id = toggle.getAttribute('data-address-toggle');
      var form = document.querySelector('[data-address-form="' + id + '"]');
      if (form) form.style.display = form.style.display === 'block' ? 'none' : 'block';
      return;
    }
    var del = e.target.closest('[data-address-delete]');
    if (del) {
      e.preventDefault();
      var msg = del.getAttribute('data-confirm-message') || 'Adresse wirklich löschen?';
      if (!window.confirm(msg)) return;
      var url = del.getAttribute('href');
      var f = document.createElement('form');
      f.method = 'post';
      f.action = url;
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f);
      f.submit();
    }
  });
})();
